import { Unstable_Grid2 as Grid, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';

import { Select, SelectData, Typography } from '@occc-app/design-system';
import { Aggregated_Audience_Operator } from '@occc/graphql';

import { useField } from 'react-final-form';
import { AudiencesSelectField } from './AudiencesSelectField';

import { CombinedAudiencesValues } from './types';
import { AudienceFormValues } from '../../types';

export type CombinedAudiencesFormContentProps = {
  name: keyof AudienceFormValues;
};

const operatorOptions: SelectData[] = [
  { label: 'In All', value: Aggregated_Audience_Operator.InAll },
  { label: 'In Any', value: Aggregated_Audience_Operator.InAny },
];

export const CombinedAudiencesFormContent = ({ name }: CombinedAudiencesFormContentProps) => {
  const { id: audienceUuid } = useParams<{ id: string }>();
  const {
    input: { value: selectedAudiences },
  } = useField<NonNullable<CombinedAudiencesValues>['audiences']>('combinedAudiences.audiences', {
    subscription: { value: true },
  });

  const selectedUuids = useMemo(() => {
    return selectedAudiences ? selectedAudiences.map((audience) => audience.uuid) : undefined;
  }, [selectedAudiences]);

  const uuidsToExclude = useMemo(() => {
    if (audienceUuid) {
      return [...(selectedUuids ?? []), audienceUuid];
    }

    return selectedUuids;
  }, [selectedUuids, audienceUuid]);

  return (
    <Stack>
      <Typography paragraph variant='subtitle1'>
        Members are in
      </Typography>

      <Grid container spacing={3}>
        <Grid xs={12} sm={4} md={3}>
          <Select
            name={`${name}.operator`}
            data={operatorOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
        <Grid xs>
          <AudiencesSelectField
            name={`${name}.audiences`}
            uuidsToExclude={uuidsToExclude}
            inputProps={{
              margin: 'none',
            }}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
